// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import tool from '@/kits/Tools.js'
import axios from 'axios'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import TFWebLog from 'tf_web_log'
import defaultApi from '@/assets/defaultAPI.js'
import GLOBAL_CONFIG from '../global/index'
// import FetchApi from '@/api/useProxy'
// import DisableDevtool from 'disable-devtool'
// DisableDevtool({
//   md5: '098f6bcd4621d373cade4e832627b4f6',
//   disableMenu: false
// })
Vue.use(VueDOMPurifyHTML)
Vue.use(ElementUI)
var tfWebLog = TFWebLog.getInstance()
// 1H5  2web  3老师端windows  4跟进页  5小程序 6安卓 7ios 8学员端PC端  9老师端Mac
tfWebLog.init(2)
Vue.prototype.$TFWebLog = tfWebLog
Vue.prototype.axios = axios
Vue.prototype.search = function (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 不需要拦截的请求
    if (config.url === 'https://webrtc.liveplay.myqcloud.com/webrtc/v1/pullstream') {
      return config
    }

    // 网校token
    if (config.url && config.url.indexOf('/user/index/checkToken') > 0) {
      var msmktoken1 = tool.getCookie('netschool_token')
      config.data = 'token=' + msmktoken1
      return config
    }

    if (config.url && config.url.indexOf('/app/report/errorReport') > 0) {
      return config
    }

    // 增加token
    var msmktoken = tool.getCookie('token')

    if (msmktoken) {
      if (config.data) {
        config.data = 'token=' + msmktoken + '&' + config.data
      } else {
        config.data = 'token=' + msmktoken
      }
    }

    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    if (response.data.token) {
      tool.setCookie('token', response.data.token, 30)
    }
    if (response.data.code === 100068 || response.data.code === 100067) {
      tool.delCookie('userInfo')
      tool.delCookie('token')
      tool.delCookie('netschool_token')
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
    // 对响应数据做点什么
    return response
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false
// https://shkt-online-live-1317978474.cos.ap-nanjing.myqcloud.com/web/config/requestApi/default.json
axios.get(`${GLOBAL_CONFIG.platformDefaultConfigDomain}/web/config/requestApi/default.json?a=${new Date().valueOf()}`).then(({ status, data }) => {
  if (status === 200 && data) {
    getBaseUrl(data)
  }
  renderPage()
}).catch((error) => {
  console.log('error: ', error)
  getBaseUrl()
  renderPage()
})

function getBaseUrl (setting) {
  if (!setting) {
    setting = defaultApi
  }
  const { SHANHU_LIVE_API, SHANHU_DATA_API, SHANHU_ONLINE_API, SHANHU_ONLINE_HY_API, SHANHU_LIVE_HY_API } = setting
  Vue.prototype.SHANHU_LIVE_API = SHANHU_LIVE_API
  Vue.prototype.SHANHU_DATA_API = SHANHU_DATA_API
  Vue.prototype.SHANHU_ONLINE_API = SHANHU_ONLINE_API
  Vue.prototype.SHANHU_ONLINE_HY_API = SHANHU_ONLINE_HY_API
  Vue.prototype.SHANHU_LIVE_HY_API = SHANHU_LIVE_HY_API
  Vue.prototype.beseUrl = tool.baseUrl4()
  Vue.prototype.beseUrl2 = tool.baseUrl4()
}

function renderPage () {
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}

// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js